module.exports = __webpack_public_path__ + "static/media/amz_REAR_RIGHT.a440698d.svg";